module.exports = __webpack_public_path__ + "img/magento.20aacdf6.webp";